import { render, staticRenderFns } from "./CartCheckoutPaymentMethod.vue?vue&type=template&id=55ca2bd9&"
import script from "./CartCheckoutPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./CartCheckoutPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports